exports.components = {
  "component---src-templates-landing-page-template-index-tsx": () => import("./../../../src/templates/landing-page-template/index.tsx" /* webpackChunkName: "component---src-templates-landing-page-template-index-tsx" */)
}

